import React, { useEffect } from 'react';
import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { createAndStartOTelSpan } from '../../helpers/open-telemetry/otel-browser-setup';

const publicRuntimeConfig = getRuntimeConfig();

const Otel: React.FC = () => {
  const otelExporterOtlpEndpoint = publicRuntimeConfig.otelExporterOtlpEndpoint;
  const openTelemetryRegexFeatureFlag = String.raw`^(?!.*(launchdarkly\.com|cookielaw\.org|onetrust\.com)).*$`;

  const { openTelemetryProcoreObservabilityKeepFeatureFlag } = useFlags();

  useEffect(() => {
    createAndStartOTelSpan(
      otelExporterOtlpEndpoint,
      openTelemetryRegexFeatureFlag,
      openTelemetryProcoreObservabilityKeepFeatureFlag
    );
  }, [
    otelExporterOtlpEndpoint,
    openTelemetryRegexFeatureFlag,
    openTelemetryProcoreObservabilityKeepFeatureFlag,
  ]);

  return null; // This  doesn't render anything
};

export default Otel;
